import React, { Component } from 'react';
import './App.css';
import Navi from './components/Navi';
import Examen from './components/Examen';
import Pregunta from './components/Pregunta';
import ExamService from './services/ExamService';
//import ExamenList from './components/ExamenList';
import Caso from './components/Caso';
import AdUnit from './components/AdUnit';
import FacebookLogin from './components/FacebookLogin';

class App extends Component {

  constructor(props){
    super(props);
    this.state = {data:[]};
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState) {

  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <Navi />
          <AdUnit hide={false} />
            {this.props.children}
          </div>
          <div>
            <AdUnit hide={false}/>
          </div>
      </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js